<template>
  <div>
    <div
      itemprop="brand"
      itemtype="https://schema.org/Brand"
      itemscope
    >
      <meta itemprop="name" :content="product.brandName">
    </div>
    <meta itemprop="image" :content="product.standardImage">
    <meta itemprop="sku" :content="product.sku">
    <div
      itemscope
      itemprop="identifier"
      itemtype="https://schema.org/PropertyValue"
    >
      <meta itemprop="sku" :content="product.sku">
    </div>
    <meta itemprop="mpn" :content="product.sku">
    <meta itemprop="url" :content="route">
    <div itemscope itemtype="https://schema.org/PriceSpecification">
      <meta itemprop="price" :content="product.priceAsNumber+''">
      <meta itemprop="priceCurrency" :content="currencyCode">
    </div>

    <div
      itemprop="offers"
      itemscope
      itemtype="https://schema.org/Offer"
    >
      <meta itemprop="price" :content="product.priceAsNumber+''">
      <meta itemprop="priceCurrency" :content="currencyCode">
      <link
        itemprop="availability"
        :href="
          product.available
            ? 'https://schema.org/InStock'
            : 'https://schema.org/OutOfStock'
        "
      >
    </div>

    <div
      v-if="yotpoReview"
      itemprop="aggregateRating"
      itemscope
      itemtype="https://schema.org/AggregateRating"
    >
      <meta itemprop="ratingValue" :content="yotpoReview.product_score">
      <meta itemprop="reviewCount" :content="yotpoReview.total_reviews">
      <meta itemprop="bestRating" content="5">
    </div>

    <div
      v-for="review in yotpoProductReview.reviews"
      :key="review.id"
      itemscope
      itemprop="review"
      itemtype="https://schema.org/Review"
    >
      <meta itemprop="name" :content="review.title">
      <div
        itemprop="author"
        itemscope
        itemtype="https://schema.org/Person"
      >
        <meta itemprop="name" :content="review.user.display_name">
      </div>
      <meta itemprop="datePublished" :content="review.created_at">
      <meta itemprop="reviewBody" :content="review.content">
      <div
        itemprop="reviewRating"
        itemscope
        itemtype="https://schema.org/Rating"
      >
        <meta itemprop="ratingValue" :content="review.score">
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type Product from '~/models/product';
import type { YotpoProductReview } from '~/constants/types/yotpo-product-review';

defineProps<{
  product: Product,
  route: string,
  currencyCode: string,
}>();

/**
 * @todo
 */
const yotpoReview = computed<any>(()=> {
  return null;
  //return config.yotpoReviewByProductSku(this.product?.sku);
});

const yotpoProductReview = ref<YotpoProductReview>({
  bottomline: {
    average_score: 0,
    custom_fields_bottomline: 0,
    organic_average_scrore: 0,
    star_distribution: {},
    total_organic_reviews: 0,
    total_review: 0,
  },
  reviews: [],
  questions: [],
});

</script>

<style scoped lang="postcss">
</style>
